import { ENDPOINTS, put } from '~/api'
import { ConfigManager } from '~/managers/ConfigManager'
import { BlockchainAddress } from '~/store/blockchainAddresses/types'
import { FlipperKey } from '~/store/flippers/types'
import { ActionTypes, Dispatch } from '~/store/types'
import { BankAccount, STABLECOIN } from '~/types'
import { FLIPPER_RESPONSE_MAP } from './const'
import { StateFlippers } from './reducer'
import {
  BANK_TRANSFER_NETWORK,
  Blockchain,
  LANDING_PAGE_ACTIONS,
  STRAITSX_LANDING_PAGE_ACTIONS,
  TRANSFER_METHOD,
} from './types'

const ACTION = ConfigManager.isBizSite() ? STRAITSX_LANDING_PAGE_ACTIONS : LANDING_PAGE_ACTIONS

const setBankTransferNetwork = (bankTransferNetwork: BANK_TRANSFER_NETWORK | null) => (
  dispatch: Dispatch<ActionTypes>
) => {
  dispatch({
    type: ACTION.SET_BANK_TRANSFER_NETWORK,
    bankTransferNetwork,
  })
}

const setSelectedBlockchainAddress = (blockchainAddress: BlockchainAddress | null) => (
  dispatch: Dispatch<ActionTypes>
) => {
  dispatch({
    type: ACTION.SET_SELECTED_BLOCKCHAIN_ADDRESS,
    selectedBlockchainAddress: blockchainAddress,
  })
}

const setSelectedBlockchain = (blockchain: Blockchain | null) => (
  dispatch: Dispatch<ActionTypes>
) => {
  dispatch(setSelectedBlockchainAddress(null))
  dispatch({
    type: ACTION.SET_SELECTED_BLOCKCHAIN,
    selectedBlockchain: blockchain,
  })
}

const setSelectedBankAccount = (bankAccount: BankAccount | null) => (
  dispatch: Dispatch<ActionTypes>
) => {
  dispatch({
    type: ACTION.SET_SELECTED_BANK_ACCOUNT,
    selectedBankAccount: bankAccount,
  })
}

export const setTransferMethod = (transferMethod: TRANSFER_METHOD | null) => (
  dispatch: Dispatch<ActionTypes>
) => {
  dispatch(setBankTransferNetwork(null))
  dispatch(setSelectedBlockchain(null))
  dispatch(setSelectedBankAccount(null))
  dispatch({
    type: ACTION.SET_TRANSFER_METHOD,
    transferMethod,
  })
}

export const setSelectedCurrency = (selectedCurrency: STABLECOIN | null) => (
  dispatch: Dispatch<ActionTypes>
) => {
  dispatch(setBankTransferNetwork(null))
  dispatch(setSelectedBlockchain(null))
  dispatch(setSelectedBankAccount(null))
  dispatch(setSelectedBlockchainAddress(null))
  dispatch({
    type: ACTION.SET_SELECTED_CURRENCY,
    selectedCurrency,
  })
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setFlippers = (keys: FlipperKey[], flipperResponse: any) => (
  dispatch: Dispatch<ActionTypes>
) => {
  const flippers = new Map<keyof StateFlippers, boolean>()

  if (keys && flipperResponse) {
    keys.forEach(key => {
      const prop = FLIPPER_RESPONSE_MAP[key]
      const enabled = flipperResponse[key] as boolean

      if (prop && enabled !== undefined) {
        flippers.set(prop, enabled)
      }
    })

    if (flippers.size > 0) {
      dispatch({
        type: ACTION.SET_FLIPPERS,
        flippers,
      })
    }
  }
}

export const acknowledgeActivationChecklist = () => () => {
  const requestBody = {
    is_acknowledged: true,
    is_dont_show_again: true,
  }
  put(ENDPOINTS.API_V3_UPDATE_ACTIVATION_CHECKLIST_ACKNOWLEDGEMENT, requestBody).catch(() => {
    // TODO: Add proper error logging
  })
}

export const setActivationChecklistClickedElement = (activationChecklistClickedElement: string) => (
  dispatch: Dispatch<ActionTypes>
) => {
  dispatch({
    type: LANDING_PAGE_ACTIONS.SET_ACTIVATION_CHECKLIST_CLICKED_ELEMENT,
    activationChecklistClickedElement,
  })
}

export const setTab = (tab: string) => (dispatch: Dispatch<ActionTypes>) => {
  dispatch(setTransferMethod(null))
  dispatch({
    type: ACTION.SET_TAB,
    tab,
  })
}
